import React, { useState} from 'react';
import '../../styles/Brands-p.css';


const importAll = (r) => {
  return r.keys().map(r);
};


const images = importAll(require.context('../../img/brands/burgerking/', false, /\.(webp|jpg|jpeg|png)$/));

const Burgerking = () => {
  const [zoomedImg, setZoomedImg] = useState(null); // Estado para controlar el zoom de las imágenes

  // Función para hacer zoom en la imagen
  const handleImageClick = (image) => {
    setZoomedImg(image);
  };

  // Función para cerrar el zoom
  const handleCloseZoom = () => {
    setZoomedImg(null);
  };

  return (
    <div className="netflix-gallery">
      {/* Título y subtítulo */}
      <div className="gallery-header">
        <h1 className="gallery-title">Burger King</h1>
        <h2 className="gallery-subtitle">
          <span className="agency-title">Agencia </span>  David Argentina
        </h2>
        <h2 className="gallery-subtitle">
          <span className="agency-title">Productora </span> Filmamo / Prójimo
        </h2>
        <h2 className="gallery-text">July 3rd, starting at 12 noon, people who came to any Burger King location in the country was able to buy their Stacker combo with a 50% discount. Part of the total raised that day, was donated to "Suena Eh!", a record label that was born in the heart of Villa La Cava.
        Sounds Eh! proposes to make visible the marginalized sectors problems through artists who can share their experiences from trap, beatbox, cumbia, reggaeton, rap and freestyle, and, in this way, help break down prejudices that run deep in society.</h2>
      </div>
      {/* Galería de imágenes */}
      <div className="brands-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Brand ${index}`}
            className={`brand-img img-${index % 5}`}
            onClick={() => handleImageClick(image)} // Al hacer clic, hacemos zoom
          />
        ))}
      </div>

      {/* Imagen con zoom */}
      {zoomedImg && (
        <div className="zoom-overlay" onClick={handleCloseZoom}>
          <img src={zoomedImg} alt="Zoomed" className="zoomed-img" />
        </div>
      )}
    </div>
  );
};

export default Burgerking;
